var diff = require("./vtree/diff.js")

module.exports = diff



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/diff.js
// module id = 180
// module chunks = 0